function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAA IDP Form - Summary: Personal details component
 * 
 */

import * as React from 'react';
import Text from '../text/Text';
import { connect } from 'react-redux';
import { Fn } from '../../../functions/Functions';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export class PersonalDetails extends React.Component {
  render() {
    const {
      club,
      contacts,
      dateOfBirth,
      dateOfTravel,
      email,
      images,
      names,
      placeOfBirth
    } = this.props;
    return /*#__PURE__*/_jsx("div", {
      id: "personal-details",
      children: /*#__PURE__*/_jsxs("div", {
        className: "details",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "text-list",
          children: [/*#__PURE__*/_jsx(Text, {
            label: "Intended travel date",
            name: "travelDate",
            value: Fn.invertDate(dateOfTravel.value)
          }), /*#__PURE__*/_jsx(Text, {
            label: "Name",
            name: "fullName",
            value: names.fullName.value
          }), /*#__PURE__*/_jsx(Text, {
            label: "Date of birth",
            name: "dateOfBirth",
            value: Fn.invertDate(dateOfBirth.value)
          }), /*#__PURE__*/_jsx(Text, {
            label: "Place of birth",
            name: "placeOfBirth",
            value: placeOfBirth.value
          }), /*#__PURE__*/_jsx(Text, {
            label: "Email",
            name: "email",
            value: email.value
          }), contacts.phoneCountryCode?.value && contacts.phoneNumber?.value ? /*#__PURE__*/_jsx(Text, {
            label: "Contact number",
            name: "phoneNumber",
            value: `${contacts.phoneCountryCode?.value} ${contacts.phoneNumber?.value}`
          }) : null, /*#__PURE__*/_jsx(Text, {
            label: "Auto club membership",
            name: "autoClub",
            value: club.autoClub?.value
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "photo",
          children: [/*#__PURE__*/_jsx("img", {
            src: images.recentPhoto.value,
            alt: "You"
          }), /*#__PURE__*/_jsx("p", {
            children: "Recent photo of yourself"
          })]
        })]
      })
    });
  }
}
_defineProperty(PersonalDetails, "defaultProps", {
  club: {
    autoClub: {
      value: ''
    }
  },
  contacts: {
    contactNumber: {
      error: false,
      value: ''
    }
  },
  dateOfBirth: {
    error: false,
    value: ''
  },
  dateOfTravel: {
    error: false,
    value: ''
  },
  email: {
    error: false,
    value: ''
  },
  images: {
    recentPhoto: {
      value: ''
    }
  },
  names: {
    fullName: {
      error: false,
      value: ''
    }
  },
  placeOfBirth: {
    error: false,
    value: ''
  }
});
const mapStateToProps = ({
  club,
  contacts,
  dateOfBirth,
  dateOfTravel,
  email,
  images,
  names,
  placeOfBirth
}) => {
  return {
    club,
    contacts,
    dateOfBirth,
    dateOfTravel,
    email,
    images,
    names,
    placeOfBirth
  };
};
const VisiblePersonalDetails = connect(mapStateToProps)(PersonalDetails);
export default VisiblePersonalDetails;